import flat from './flat'
import { SHOP_ID } from '@/utils/const'
import { ACT_DETAILS } from '@/utils/cartConst'
import { baseUrl, cartUrl, homePageUrl, detailUrl } from './const'
import { delay } from '@/utils'

//获取铜板数量
export function getCredit() {
  return flat(`${baseUrl}/creditmall/get_credit`)
}

/**
 * 加入购物车 或者修改数量
 * @param {object} param
 * @param {number} [param.shopId]
 * @param {number} param.subItemId
 * @param {number} param.count //数量
 * @param {boolean} param.choice //是否默认选中
 * @returns
 */
export function addCart(param) {
  const { shopId = SHOP_ID, subItemId, count, choice = false } = param
  return flat(`${cartUrl}/modify_goods?choice=${choice}`, {
    method: 'POST',
    body: {
      shopId: shopId,
      subItemId,
      count,
    },
  })
}

/**
 * 获取结算信息
 * @param {number} shopId
 * @returns
 */
export function getPostageInfo(shopId = SHOP_ID, activityIds) {
  ///api/mall/proxy/get_money
  const p = activityIds ? `&activityIds=${activityIds}` : ''
  return flat(`${cartUrl}/get_money?shopId=${shopId}${p}`)
}

/**
 * 根据itemId获取优惠券列表
 * @param {number} shopId
 * @returns
 */
export function getCouponData(itemId, shopId = SHOP_ID) {
  return flat(`${detailUrl}/get_coupon_list?shopId=${shopId}&itemId=${itemId}`)
}

/**
 * 领券
 * @param {number} couponId
 * @param {number} shopId
 * @returns
 */
export function awardCoupon(couponId, shopId = SHOP_ID) {
  return flat(`${detailUrl}/send_coupon?shopId=${shopId}&couponId=${couponId}`, {
    method: 'POST',
    body: {},
  })
}

/**
 *
 */

export function getCartSummaryInfo(shopId = SHOP_ID) {
  //https://learn.baicizhan.com/api/mall/proxy/get_cart_sku_count
  // return flat(`https://learn.baicizhan.com/api/mall/proxy/get_notify`)

  return flat(`${cartUrl}/get_cart_sku_count?shopId=${shopId}`)
}

export function getSkeleton() {
  return flat(`${baseUrl}/index_info`)
}

export function getSearchData(queryString) {
  return flat(`${homePageUrl}/search_goods`, {
    method: 'POST',
    body: {
      queryString,
      pageIndex: 1,
      pageSize: 100,
      showType: 0, //0:显示 1:隐藏 999:全部
      shopId: SHOP_ID,
    },
  })
}

//猜你喜欢
export function getRecommend(shopId = SHOP_ID) {
  return flat(`${cartUrl}/get_recommand_goods?shopId=${shopId}`)
}

//获取活动id
/**
 * @deprecated
 * @returns
 */
export function getActId() {
  return Promise.race([
    delay(800),
    new Promise(resolve => {
      flat(`${homePageUrl}/get_service_time`)
        .then(res => {
          const time = !res.error ? res.data : new Date().getTime()
          const diff = time - new Date().getTime()
          window.__timeDiff__ = diff
          for (let i = 0, len = ACT_DETAILS.length; i < len; i++) {
            const { start, end, id } = ACT_DETAILS[i]
            if (time >= start && time < end) {
              resolve(id)
              return
            }
          }
          resolve('')
        })
        .catch(() => {
          resolve('')
        })
    }),
  ])
}

/**
 * 获取人群
 */
export function getUserGroup() {
  return flat(`${baseUrl}/get_group?shopId=${SHOP_ID}`)
}
